import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bareBranch',
      d: 'M0.5,-6.5h0.5v0.5h-0.5zM-3.5,-4.5h0.5v0.5h-0.5zM2.5,-4.5h1v0.5h-1zM-3.5,-4h1v0.5h-1zM2.5,-4h0.5v0.5h-0.5zM-4,-3.5h2.5v0.5h-2.5zM1.5,-3.5h1v0.5h-1zM-2,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M0.5,-5.5h0.5v1h-0.5zM-1.5,-4.5h0.5v0.5h-0.5zM0,-4.5h1v0.5h-1zM1,-4h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM1,-3h1v0.5h-1zM-2,-2.5h0.5v0.5h-0.5zM0.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h0.5v0.5h-0.5zM0.5,-2h1v0.5h-1zM-1,-1.5h3v0.5h-3zM1,-1h1.5v2h-1.5zM-2,1h0.5v0.5h-0.5zM0.5,1h2v0.5h-2zM-1.5,1.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-1.5,-5.5h2v0.5h-2zM-1.5,-5h1.5v0.5h-1.5zM-1,-4.5h1v0.5h-1zM-1.5,-3.5h1.5v0.5h-1.5zM-1.5,-3h2v1h-2zM-1,-2h1.5v0.5h-1.5zM-2,-1.5h1v0.5h-1zM-2.5,-1h3.5v2h-3.5zM-1.5,1h2v0.5h-2z',
    },
    {
      paint: 'scarfRed',
      d: 'M-1,-6.5h1.5v0.5h-1.5zM-1.5,-4h2.5v0.5h-2.5zM0,-3.5h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowmanCoal',
      d: 'M-1,-7.5h1.5v0.5h-1.5zM-1,-7h2v0.5h-2zM1,-6.5h0.5v0.5h-0.5zM-1.5,-6h3v0.5h-3z',
    },
    { paint: 'snowmanCarrot', d: 'M0,-5h0.5v0.5h-0.5zM1,-4.5h0.5v0.5h-0.5z' },
  ],
  pixels: 145,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'bareBranch',
      d: 'M-3.5,-5h0.5v0.5h-0.5zM2.5,-5h1v1h-1zM-3.5,-4.5h1v0.5h-1zM0,-4.5h0.5v0.5h-0.5zM-4,-4h2v0.5h-2zM2,-4h1.5v0.5h-1.5zM-2.5,-3.5h1v0.5h-1zM1.5,-3.5h2v0.5h-2zM2.5,-3h1v1.5h-1zM2.5,-1.5h0.5v2.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M-0.5,-6.5h1v0.5h-1zM0.5,-6h0.5v0.5h-0.5zM0,-5.5h1v0.5h-1zM-1.5,-5h0.5v0.5h-0.5zM0.5,-5h0.5v0.5h-0.5zM-1,-4.5h1v0.5h-1zM0.5,-4h1v0.5h-1zM1,-3.5h0.5v0.5h-0.5zM-2,-3h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5zM0.5,-3h1.5v0.5h-1.5zM0.5,-2.5h1v0.5h-1zM-1.5,-2h3v0.5h-3zM1,-1.5h1v0.5h-1zM1,-1h1.5v2h-1.5zM-2,1h0.5v0.5h-0.5zM0.5,1h2v0.5h-2zM-1.5,1.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-1,-6.5h0.5v0.5h-0.5zM-1.5,-6h2v0.5h-2zM-1.5,-5.5h1.5v0.5h-1.5zM-1,-5h1v0.5h-1zM-1.5,-4h1.5v1h-1.5zM-1.5,-3h1v0.5h-1zM0,-3h0.5v0.5h-0.5zM-1.5,-2.5h2v0.5h-2zM-2,-1.5h3v0.5h-3zM-2.5,-1h3.5v2h-3.5zM-1.5,1h2v0.5h-2z',
    },
    {
      paint: 'scarfRed',
      d: 'M-1.5,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM0,-4h0.5v0.5h-0.5zM0,-3.5h1v0.5h-1z',
    },
    { paint: 'snowmanCarrot', d: 'M0,-5h0.5v0.5h-0.5z' },
    { paint: 'wheat', d: 'M3,-7.5h1v0.5h-1zM3,-7h1.5v1h-1.5zM3,-6h1v1h-1z' },
  ],
  pixels: 162,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M0,-4.5h1v0.5h-1zM0.5,-4h0.5v1h-0.5zM0,-3h1.5v0.5h-1.5zM1,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM0.5,-2h1.5v1h-1.5zM-1.5,-1h0.5v0.5h-0.5zM-0.5,-1h3v0.5h-3zM-3,-0.5h0.5v0.5h-0.5zM-1,-0.5h3v0.5h-3zM-3.5,0h1.5v0.5h-1.5zM1,0h1v1h-1zM-3,0.5h1v0.5h-1zM3,0.5h0.5v0.5h-0.5zM-3,1h1.5v0.5h-1.5zM0.5,1h3.5v0.5h-3.5zM-3,1.5h7v0.5h-7zM-1,2h3v0.5h-3z',
    },
    {
      paint: 'bareBranch',
      d: 'M-3.5,-4h0.5v1h-0.5zM2.5,-3.5h1v0.5h-1zM-3.5,-3h1v0.5h-1zM2.5,-3h0.5v0.5h-0.5zM-4,-2.5h2.5v0.5h-2.5zM1.5,-2.5h1v0.5h-1zM2,-0.5h0.5v1h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-1,-4.5h1v0.5h-1zM-1.5,-4h2v0.5h-2zM-1.5,-3.5h1.5v1h-1.5zM-1.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h1.5v0.5h-1.5zM-2,-1.5h2.5v0.5h-2.5zM-2.5,-1h1v0.5h-1zM-1,-1h0.5v0.5h-0.5zM-2.5,-0.5h1.5v0.5h-1.5zM-2,0h3v1h-3zM-1.5,1h2v0.5h-2z',
    },
    { paint: 'scarfRed', d: 'M-1,-2.5h2v0.5h-2zM0,-2h0.5v0.5h-0.5z' },
    { paint: 'snowmanCoal', d: 'M2.5,-0.5h1v1h-1zM2,0.5h1v0.5h-1z' },
    { paint: 'snowmanCarrot', d: 'M0,-3.5h0.5v0.5h-0.5z' },
  ],
  pixels: 140,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
